import { FC } from 'react';
import { Link } from 'react-router-dom';

const UnauthorizedPage: FC = () => {
    return (
        <div className="min-h-screen bg-slate-900 flex flex-col justify-center items-center p-4">
            <div className="w-full max-w-md text-center">
                <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-8">
                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-red-400 mx-auto mb-6">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="15" y1="9" x2="9" y2="15" />
                        <line x1="9" y1="9" x2="15" y2="15" />
                    </svg>
                    <h1 className="text-2xl font-bold text-white mb-4">Accesso Negato</h1>
                    <p className="text-slate-400 mb-6">
                        Non disponi dei permessi necessari per visualizzare questa pagina.
                    </p>
                    <Link to="/" className="mt-8 inline-block px-6 py-2 rounded-lg text-white font-semibold bg-sky-600 hover:bg-sky-500 transition-colors">
                        Torna alla Dashboard
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default UnauthorizedPage;
